import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { SmevMonitoring } from './SmevMonitoring';

export const SmevMonitoringPage = () => {
  useTitle('Мониторинг сообщений СМЭВ');

  return (
    <Layout withFooter>
      <SmevMonitoring />
    </Layout>
  );
};
